import { useSlate } from 'slate-react';
import { isMarkActive, toggleMark } from 'slate/functions';
import { forwardRef } from 'react';

interface MarkButtonProps {
  format: string;
  icon: string;
  css?: string;
  text?: string;
}

export const MarkButton = forwardRef<HTMLButtonElement, MarkButtonProps>(({ format, icon, css }, ref) => {
  const editor = useSlate();
  return (
    <button
      ref={ref}
      className={`${css}  ${isMarkActive(editor, format) ? 'active' : ''}`}
      onMouseDown={(event) => {
        event.preventDefault();
        toggleMark(editor, format);
      }}
    >
      <i className={`fa-regular fa-${icon}`} />
    </button>
  );
});
